import React from "react";

// router
import { BrowserRouter, Route, Routes } from "react-router-dom";

// pages
import Layout from "../pages/layout";
import { Login } from "../pages/auth";
import PrivateRoute from "./routes/PrivateRoute";

const EntryRoute = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default EntryRoute;
